/*=========================================================================================
  File Name: moduleSpaceGetters.js
  Description: Space Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getProject: state => (id) => state.workspaceProjects.find((project => project.id == id))

  // getWorkspaceProjects:  state => (id) => state.workspaceProjects.find((project => project.id == id))
}
